import { DateTime } from '@ksyos/date-time';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { servicesWithDisabledRequestPdf } from '../../../../../../common/utils/servicesWithDisabledRequestPdf';
import { translateKey } from '../../../../../translate';
import { AssignProcessToColleagueButton } from '../../../../elements/carePathButtons/AssignProcessToColleagueButton';
import { BecomeRequesterButton } from '../../../../elements/carePathButtons/BecomeRequesterButton';
import { CancelProcessButton } from '../../../../elements/carePathButtons/CancelProcessButton';
import { EditRequestButton } from '../../../../elements/carePathButtons/EditRequestButton';
import { PrintPdfButton } from '../../../../elements/carePathButtons/PrintPdfButton';
import { TakeRequestButton } from '../../../../elements/carePathButtons/TakeRequestButton';
import { TakeRequestFromOrganizationButton } from '../../../../elements/carePathButtons/TakeRequestFromOrganizationButton';
import { ButtonContainer, FormLabel, FormParagraph } from '../../../../elements/common';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { getStatusLabel } from '../../../../elements/getStatusLabel';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';

export function OsasqV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <>
            {!!props.addProcedure && !props.process.procedure && (
                <ProcessContainer>
                    <ProcessItemHeader
                        date={props.process.dateSent || (props.request && props.request.dateSent)}
                        isFirstItem={props.isFirstItem}
                        isFirstProcess={props.itemState.isFirstProcess}
                        isItemOpen={props.itemState.isOpen}
                        onToggle={async (isOpened) =>
                            await props.updateItemState({ ...props.itemState, isOpen: isOpened })
                        }
                        organizationName={props.process.requesterOrganization?.name}
                        practitionerName={
                            props.process.requesterPractitioner
                                ? getDisplayName(props.process.requesterPractitioner)
                                : undefined
                        }
                        process={{ ...props.process, statusLabel: getStatusLabel(props.process) }}
                        serviceType={props.process.serviceType}
                        title={getServiceLabel(props.process.code, 'request', props.process.name)}
                    />

                    {props.request.customControlData.email_address && (
                        <HorizontalFormGroupRead>
                            <FormLabel>{translateKey('common.emailAddress')}</FormLabel>
                            <InputContainer className="mb-3">
                                <FormParagraph>{props.request.customControlData.email_address}</FormParagraph>
                            </InputContainer>
                        </HorizontalFormGroupRead>
                    )}

                    {props.request.customControlData.resend_date && (
                        <HorizontalFormGroupRead>
                            <FormLabel>{translateKey('processThirdPartyMessages.nextScheduledDateTime')}</FormLabel>
                            <InputContainer>
                                <FormParagraph>
                                    {DateTime.from(props.request.customControlData.resend_date).format('DD-MM-YYYY')}
                                </FormParagraph>
                            </InputContainer>
                        </HorizontalFormGroupRead>
                    )}
                    <ButtonContainer
                        alignRight
                        buttons={[
                            <CancelProcessButton
                                cancelProcess={props.removeProcess}
                                request={props.request}
                                serviceCode={props.serviceCode}
                            />,
                            <>
                                {!servicesWithDisabledRequestPdf.includes(props.request.service.code) && (
                                    <PrintPdfButton request={props.request} />
                                )}
                            </>,
                            <EditRequestButton
                                editRequest={props.editRequest}
                                request={props.request}
                            />,
                            <AssignProcessToColleagueButton
                                addReport={props.addReport}
                                assignProcessColleague={props.assignProcessColleague}
                                request={props.request}
                            />,
                            <TakeRequestButton
                                reloadProcess={props.reloadProcess}
                                request={props.request}
                            />,
                            <TakeRequestFromOrganizationButton
                                addProcedure={props.addProcedure}
                                reloadProcess={props.reloadProcess}
                                request={props.request}
                            />,
                            <BecomeRequesterButton
                                reloadProcess={props.reloadProcess}
                                request={props.request}
                            />,
                        ]}
                    />
                </ProcessContainer>
            )}
        </>
    );
}
